export var TransportChannelType;
(function (TransportChannelType) {
    TransportChannelType["Websocket"] = "websocket";
    TransportChannelType["QUIC"] = "quic";
    TransportChannelType["HTTP"] = "http";
})(TransportChannelType || (TransportChannelType = {}));
